import React from 'react';

interface SupportIconProps {
  className?: string;
  style?: React.CSSProperties;
}

const SupportIcon: React.FC<SupportIconProps> = ({ className, style }) => (
  <img
    src={`${process.env.PUBLIC_URL}/Frame.png`}
    alt="Support"
    className={className}
    style={{ width: '1em', height: '1em', objectFit: 'contain', verticalAlign: '-0.125em', filter: 'brightness(0)', ...style }}
  />
);

export default SupportIcon;
